// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToggleArrow_wrapper__GMb1B","arrow":"ToggleArrow_arrow__AW7Cj","active":"ToggleArrow_active__0dReo","dark":"ToggleArrow_dark__R_pLC"};